import { ICarouselSectionEntry } from '../../../../contentful/types/ICarouselSectionEntry';
import Carousel from '../../../../ui/components/Carousel/Carousel';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';

interface ICarouselsSectionProps {
	section: ICarouselSectionEntry;
}

export default function CarouselSection({ section }: ICarouselsSectionProps) {
	return (
		<Carousel
			title={section.fields.title}
			subtitle={section.fields.subtitle}
			description={section.fields.description}
			items={section.fields.items}
			root={section.fields.link as PageRoutes}
			categories={section.fields.categories}
		/>
	);
}
